module.exports = __webpack_public_path__ + "img/uje-removebg-preview.175a4456.png";